export const SET_FOURNISSEURS_LOADING = "SET_FOURNISSEURS_LOADING";
export const SET_FOURNISSEURS_ERROR = "SET_FOURNISSEURS_ERROR";

export const FETCH_FOURNISSEURS_REQUEST = "FETCH_FOURNISSEURS_REQUEST";
export const FETCH_FOURNISSEURS_SUCCESS = "FETCH_FOURNISSEURS_SUCCESS";
export const FETCH_FOURNISSEURS_FAIL = "FETCH_FOURNISSEURS_FAIL";

export const CREATE_FOURNISSEUR_REQUEST = "CREATE_FOURNISSEUR_REQUEST";
export const CREATE_FOURNISSEUR_SUCCESS = "CREATE_FOURNISSEUR_SUCCESS";
export const CREATE_FOURNISSEUR_FAIL = "CREATE_FOURNISSEUR_FAIL";

export const UPDATE_FOURNISSEUR_REQUEST = "UPDATE_FOURNISSEUR_REQUEST";
export const UPDATE_FOURNISSEUR_SUCCESS = "UPDATE_FOURNISSEUR_SUCCESS";
export const UPDATE_FOURNISSEUR_FAIL = "UPDATE_FOURNISSEUR_FAIL";

export const DELETE_FOURNISSEUR_REQUEST = "DELETE_FOURNISSEUR_REQUEST";
export const DELETE_FOURNISSEUR_SUCCESS = "DELETE_FOURNISSEUR_SUCCESS";
export const DELETE_FOURNISSEUR_FAIL = "DELETE_FOURNISSEUR_FAIL";

export const setFournisseursLoading = (v) => ({ type: SET_FOURNISSEURS_LOADING, payload: v });
export const setFournisseursError = (msg) => ({ type: SET_FOURNISSEURS_ERROR, payload: msg });

export const fetchFournisseursRequest = () => ({ type: FETCH_FOURNISSEURS_REQUEST });
export const fetchFournisseursSuccess = (data) => ({ type: FETCH_FOURNISSEURS_SUCCESS, payload: data });
export const fetchFournisseursFail = (err) => ({ type: FETCH_FOURNISSEURS_FAIL, payload: err });

export const createFournisseurRequest = (payload) => ({ type: CREATE_FOURNISSEUR_REQUEST, payload });
export const createFournisseurSuccess = (data) => ({ type: CREATE_FOURNISSEUR_SUCCESS, payload: data });
export const createFournisseurFail = (err) => ({ type: CREATE_FOURNISSEUR_FAIL, payload: err });

export const updateFournisseurRequest = (id, payload) => ({ type: UPDATE_FOURNISSEUR_REQUEST, payload: { id, payload } });
export const updateFournisseurSuccess = (data) => ({ type: UPDATE_FOURNISSEUR_SUCCESS, payload: data });
export const updateFournisseurFail = (err) => ({ type: UPDATE_FOURNISSEUR_FAIL, payload: err });

export const deleteFournisseurRequest = (id) => ({ type: DELETE_FOURNISSEUR_REQUEST, payload: { id } });
export const deleteFournisseurSuccess = (id) => ({ type: DELETE_FOURNISSEUR_SUCCESS, payload: id });
export const deleteFournisseurFail = (err) => ({ type: DELETE_FOURNISSEUR_FAIL, payload: err });
